import { render, staticRenderFns } from "./RatingsSummaryModal.vue?vue&type=template&id=f432eb44&scoped=true"
import script from "./RatingsSummaryModal.vue?vue&type=script&lang=js"
export * from "./RatingsSummaryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f432eb44",
  null
  
)

export default component.exports